import script from "./FooterBottom.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterBottom.component.vue?vue&type=script&lang=ts&setup=true"

import "./FooterBottom.component.vue?vue&type=style&index=0&id=00f040fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f040fa"]])

export default __exports__